import type { ReactNode } from "react";

export type StampTone = "ink" | "primary" | "accent" | "strike" | "ok";

export interface StampProps {
  children: ReactNode;
  tone?: StampTone;
  className?: string;
}

const TONE_CLASS: Record<StampTone, string> = {
  ink: "border-[var(--secondary)] text-[var(--secondary)]",
  primary: "border-[var(--primary)] text-[var(--primary)]",
  accent: "border-[var(--accent)] text-[var(--accent-strong)]",
  strike: "border-[var(--strike)] text-[var(--strike)]",
  ok: "border-[var(--ok)] text-[var(--ok)]",
};

export function Stamp({ children, tone = "ink", className = "" }: StampProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 border-2 px-2 py-0.5 -rotate-2 ${TONE_CLASS[tone]} mono text-[10.5px] font-bold uppercase tracking-[0.12em] ${className}`}
    >
      {children}
    </span>
  );
}
